/*
 * @Author: Jhonsem
 * @Date: 2020-12-21 16:42:01
 * @Last Modified by: jhonsem
 * @Last Modified time: 2021-03-29 09:54:41
 * 初始化流程的生命周期：
 * 1.launchParamsAndDeviceInfoReady   （launch_params和device_info）
 * 2.localSettingReady (本地setting的本地读取和处理准备)
 * 3.masterUserIdReady (masterUserId主账号id，用于cg请求必要参数)
 * 4.masterUserIdLoginedReady (masterUserId主账号id，在后台注册成功)
 * 5.jsFrameReady (vue框架的实例化完成)
 * 6.onlineSettingReady (线上setting的获取)
 */
import local_setting_init from "./local_setting_lifecycle";
import launch_params_and_device_info_init from "./launch_and_device_lifecycle";
import js_frame_init from "./js_frame_lifecycle";
import master_user_id_init from "./master_user_id_lifecycle";
import online_setting_init from "./online_setting_lifecycle";
import master_user_id_login_init from "./master_user_id_login_init";
interface ParamsType {
  launchParamsAndDeviceInfoReady: (params: any) => any;
  localSettingReady: (params: any) => any;
  masterUserIdReady: (params: any) => any;
  masterUserIdLoginedReady: (params: any) => any;
  onlineSettingReady: (params: any) => any;
  jsFrameDomReady: (params: any) => any;
  insApiLunch: (params: any) => any;
}

export default class InitLifyCycle {
  private params: ParamsType;

  constructor(params: ParamsType) {
    this.params = params;
    this.run();
  }

  private async runQueItem(
    initFunction: () => any,
    lifeCycleName:
      | "launchParamsAndDeviceInfoReady"
      | "localSettingReady"
      | "masterUserIdReady"
      | "masterUserIdLoginedReady"
      | "onlineSettingReady"
      | "jsFrameDomReady"
      | "insApiLunch"
  ) {
    try {
      //
      const result = await initFunction();
      console.info(
        `%c ============= ${lifeCycleName} ==============`,
        "color: #a0c3ff;font-weight:bold"
      );
      this.params[lifeCycleName](result);
      return true;
    } catch (error) {
      //
      return Promise.reject(error);
    }
  }

  private async run() {
    try {
      // ============= launchParamsAndDeviceInfoReady ==============
      await this.runQueItem(
        launch_params_and_device_info_init,
        "launchParamsAndDeviceInfoReady"
      );
      // ============= localSettingReady ==============
      await this.runQueItem(local_setting_init, "localSettingReady");
      // ============= masterUserIdReady ==============
      await this.runQueItem(master_user_id_init, "masterUserIdReady");
      // ============= jsFrameReady ==============
      await this.runQueItem(js_frame_init, "jsFrameDomReady");
      // ============= masterUserIdLoginedReady ==============
      await this.runQueItem(
        master_user_id_login_init,
        "masterUserIdLoginedReady"
      );
      // ============= onlineSettingReady ==============
      await this.runQueItem(online_setting_init, "onlineSettingReady");
      // tslint:disable-next-line: no-empty
      this.runQueItem(() => {}, "insApiLunch");
    } catch (error) {
      //
      return Promise.reject(error);
    }
  }
}
